import React from "react";
import { X } from "lucide-react";
import { useComingSoon } from "../utils/useComingSoon";

export default function ComingSoonModal() {
    const { isComingSoonOpen, hideComingSoon, comingSoonTitle, comingSoonMessage } = useComingSoon();

    if (!isComingSoonOpen) return null;

    return (
        <div className="fixed inset-0 z-[10000] flex items-center justify-center p-4 sm:p-6">
            {/* Backdrop */}
            <div
                className="absolute inset-0 bg-black/60 backdrop-blur-sm animate-fadeIn"
                onClick={hideComingSoon}
            />

            {/* Modal Content */}
            <div className="relative bg-[#FAFAFA] border border-black/10 w-full max-w-md p-8 sm:p-12 shadow-[0_20px_50px_rgba(0,0,0,0.3)] animate-slideInUp rounded-[2rem]">
                <button
                    onClick={hideComingSoon}
                    className="absolute top-4 right-4 text-black/40 hover:text-black hover:bg-black/5 transition-all p-2 rounded-full"
                >
                    <X size={20} />
                </button>

                <div className="text-center">
                    <div className="w-16 h-16 bg-jazz-brown/10 rounded-full flex items-center justify-center mx-auto mb-6">
                        <construction className="text-jazz-brown" size={32} />
                    </div>

                    <h3
                        className="text-2xl font-serif italic text-black mb-4"
                    >
                        {comingSoonTitle || "Coming Soon"}
                    </h3>

                    <p
                        className="text-black/60 text-sm mb-8 leading-relaxed font-medium"
                    >
                        {comingSoonMessage || "We're fine-tuning the rhythm. This feature is currently under development and will be launching soon."}
                    </p>

                    <button
                        onClick={hideComingSoon}
                        className="w-full bg-black text-white py-4 text-[10px] font-bold tracking-[0.2em] uppercase rounded-xl hover:bg-jazz-brown transition-colors duration-300 shadow-md"
                    >
                        BACK TO APP
                    </button>
                </div>
            </div>

            <style jsx>{`
        @keyframes fadeIn {
          from { opacity: 0; }
          to { opacity: 1; }
        }
        @keyframes slideInUp {
          from { 
            opacity: 0;
            transform: translateY(20px) scale(0.95);
          }
          to { 
            opacity: 1;
            transform: translateY(0) scale(1);
          }
        }
        .animate-fadeIn {
          animation: fadeIn 0.3s ease-out forwards;
        }
        .animate-slideInUp {
          animation: slideInUp 0.4s cubic-bezier(0.16, 1, 0.3, 1) forwards;
        }
      `}</style>
        </div>
    );
}
